import { render, staticRenderFns } from "./PopupByURLComponent.vue?vue&type=template&id=3b85804c"
import script from "./PopupByURLComponent.vue?vue&type=script&lang=js"
export * from "./PopupByURLComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupByURLComponent.vue?vue&type=style&index=0&id=3b85804c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports